import { connect } from 'react-redux';
import ticketMenuItem from '../components/ticket-menu-item';
import { getWorklistData } from '../../../worklist/containers/worklist-actions';

const mapStateToProps = state => ({
  count: state.worklist.totalDataCount,
});

const mapDispatchToProps = {
  getWorklistData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ticketMenuItem);
